import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { ComingSoonPage } from "~/pages/coming-soon-page"

const rootEl = document.getElementById("react-root")
if (rootEl) {
  const root = createRoot(rootEl)
  root.render(
    <StrictMode>
      <ComingSoonPage />
    </StrictMode>
  )
} else {
  console.error("no react-root")
}
